export enum InstrumentType {
    Equity = 1,
    Cash = 2,
    UnitTrust = 3,
}